/**
 * Registrierung der Widgets
 */
import { widgetRegistry } from './registry';
import HelloWorldWidget from './components/HelloWorldWidget';
import PieChartOverview from './components/PieChartOverview';
import PieChartOverviewSettings from './components/PieChartOverview/PieChartOverviewSettings';
import JahresStatistikBarChart from './components/JahresStatistikBarChart';
import JahresStatistikBarChartSettings from './components/JahresStatistikBarChart/JahresStatistikBarChartSettings';
import SendMail from './components/SendMail';
import { ListWidget, ListWidgetSettings } from './components/ListWidget';
// Import der Konfigurationen
import { areaConfig } from './components/ListWidget/config';

const DEBUG_MODE = process.env.NODE_ENV === "development" || window._env_?.REACT_APP_LOGGING === "true";
// Registrierung der Test-Widgets nur in der Entwicklungsumgebung
if (DEBUG_MODE) {
  // Registrierung des HelloWorldWidget
  widgetRegistry.registerWidget({
    type: 'hello-world',
    name: 'Hallo Welt Widget',
    description: 'Ein einfaches Beispiel-Widget für Testzwecke',
    defaultConfig: {
      title: 'Hallo Welt Widget',
      isActive: true,
      position: 0,
      globalSettings: {}
    },
    component: HelloWorldWidget
  });

  // Registrierung des SendMail-Widgets
  widgetRegistry.registerWidget({
    type: 'send-mail',
    name: 'E-Mail senden',
    description: 'E-Mail-Widget für den Versand von Info-Mails',
    defaultConfig: {
      title: 'E-Mail senden',
      isActive: true,
      position: 3,
      size: { width: 2, height: 1 }, // Standardgröße: 2x1
      globalSettings: {}
    },
    component: SendMail
  });
}

// Registrierung des PieChartOverview-Widgets
widgetRegistry.registerWidget({
  type: 'pie-chart-overview',
  name: 'Pie Chart Overview',
  description: 'Zeigt Untersuchungen in einem Donut-Diagramm an',
  defaultConfig: {
    title: 'Untersuchungen Übersicht',
    isActive: true,
    position: 1,
    size: { width: 2, height: 1 }, // Neue Standardgröße: 2x1
    globalSettings: {}
  },
  component: PieChartOverview,
  settingsComponent: PieChartOverviewSettings
});

// Registrierung des JahresStatistikBarChart-Widgets
widgetRegistry.registerWidget({
  type: 'jahres-statistik-bar-chart',
  name: 'Jahresstatistik Balkendiagramm',
  description: 'Zeigt monatliche Statistiken in einem Balkendiagramm an',
  defaultConfig: {
    title: 'Jahresstatistik',
    isActive: true,
    position: 2,
    size: { width: 4, height: 1 }, // Neue Standardgröße: 4x1
    globalSettings: {}
  },
  component: JahresStatistikBarChart,
  settingsComponent: JahresStatistikBarChartSettings
});


// Registrierung des ListWidget
widgetRegistry.registerWidget({
  type: 'list-widget',
  name: 'Aggregated List Widget',
  description: 'Zeigt eine aggregierte Liste mit Tätigkeitsbereichen oder Vorsorgearten an',
  defaultConfig: {
    ...areaConfig,
    localSettings: {
      selectedAreas: [],
      statusFilter: '',
      isTop5Mode: true
    }
  },
  component: ListWidget,
  settingsComponent: ListWidgetSettings
});
